"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUNCTION_LOACTIONS = exports.FunctionsListCrawlerPathLinkType = exports.FUNCTION_REPORTER_TYPE = exports.FUNCTION_IDS = void 0;
const General_1 = require("./General");
var FUNCTION_IDS;
(function (FUNCTION_IDS) {
    FUNCTION_IDS["ANALYTICS_LOG_EVENT"] = "analyticsLogEvent";
    FUNCTION_IDS["ARITHMETIC"] = "arithmetic";
    FUNCTION_IDS["ARRAY_FROM_OBJECT"] = "arrayFromObject";
    FUNCTION_IDS["AVOID_SUSPENSION"] = "avoidSuspension";
    FUNCTION_IDS["BACK_SCREEN"] = "backSreen";
    FUNCTION_IDS["BASED_ON_CURRENT_OS"] = "basedOnCurrentOs";
    FUNCTION_IDS["BIOMETRIC_AUTH"] = "biometricAuth";
    FUNCTION_IDS["BUBBLE"] = "bubble";
    FUNCTION_IDS["CHANGE_MY_PASSWORD"] = "changeMyPassword";
    FUNCTION_IDS["CHRONOMETER"] = "chronometer";
    FUNCTION_IDS["COLLECTION_FILTER"] = "collectionFilter";
    FUNCTION_IDS["COLLECTION_ITERATION"] = "collectionIteration";
    FUNCTION_IDS["CONCAT"] = "concat";
    FUNCTION_IDS["CONDITIONAL"] = "conditional";
    FUNCTION_IDS["CONFIRMATION_ALERT"] = "confirmationAlert";
    FUNCTION_IDS["COPY_CLIPBOARD"] = "copyClipboard";
    FUNCTION_IDS["COPY_DATA_FROM_PATH"] = "copyDataFromPath";
    FUNCTION_IDS["DEBOUNCE"] = "debounce";
    FUNCTION_IDS["DELETE_ALL_DATA_LOCAL"] = "deleteAllDataLocal";
    FUNCTION_IDS["DELETE_DATA_DB"] = "deleteDataDB";
    FUNCTION_IDS["DELETE_DATA_LOCAL"] = "deleteDataLocal";
    FUNCTION_IDS["DISMISS_KEYBOARD"] = "dismissKeyboard";
    FUNCTION_IDS["DOWNLOAD_FILE"] = "downloadFile";
    FUNCTION_IDS["FOR_EACH"] = "forEach";
    FUNCTION_IDS["FORGET_PASSWORD"] = "forgetPassword";
    FUNCTION_IDS["GENERATE_SWIPER_CONTENT"] = "generateSwiperContent";
    FUNCTION_IDS["GEOCODING"] = "geocoding";
    FUNCTION_IDS["GEOFIRE_GET"] = "geoFireGet";
    FUNCTION_IDS["GEOFIRE_GET_ALL"] = "geoFireGetAll";
    FUNCTION_IDS["GEOFIRE_LISTEN_ITEM"] = "geoFireListenItem";
    FUNCTION_IDS["GEOFIRE_QUERY"] = "geoFireQuery";
    FUNCTION_IDS["GEOFIRE_QUERY_ALL"] = "geoFireQueryAll";
    FUNCTION_IDS["GEOFIRE_REMOVE"] = "geoFireRemove";
    FUNCTION_IDS["GEOFIRE_SET"] = "geoFireSet";
    FUNCTION_IDS["GEOFIRE_SET_MULTIPLE"] = "geoFireSetMultiple";
    FUNCTION_IDS["GET_ALL_USERS"] = "getAllUsers";
    FUNCTION_IDS["GET_APP_USERS"] = "getAppUsers";
    FUNCTION_IDS["GET_CONNECTION_TYPE"] = "getConnectionType";
    FUNCTION_IDS["GET_DATA_DB"] = "getDataDB";
    FUNCTION_IDS["GET_DATA_FROM_OTHER_USER"] = "getDataFromOtherUser";
    FUNCTION_IDS["GET_DATA_LOCAL"] = "getDataLocal";
    FUNCTION_IDS["GET_DEVICE_INFO"] = "getDeviceInfo";
    FUNCTION_IDS["GET_DISTANCE"] = "getDistance";
    FUNCTION_IDS["GET_LOCATION"] = "getLocation";
    FUNCTION_IDS["GET_SCREEN_DIMENTION"] = "getScreenDimention";
    FUNCTION_IDS["GET_USER_OTHER_APP"] = "getUserOtherApp";
    FUNCTION_IDS["GLOBAL_FORMATER"] = "globalFormatter";
    FUNCTION_IDS["HIDE_BUBBLE"] = "hiddeBubble";
    FUNCTION_IDS["IN_APP_PURCHASE"] = "inAppPurchase";
    FUNCTION_IDS["IN_APPPURCHASE_GET_HISTORY"] = "inAppPurchaseGetHistory";
    FUNCTION_IDS["INPUT_DIALOG"] = "inputDialog";
    FUNCTION_IDS["INTERESTITIAL_ADS"] = "interstitialAds";
    FUNCTION_IDS["IS_AUDIO_PLAYING"] = "isAudioPlaying";
    FUNCTION_IDS["IS_COORDINATE_INSIDE_POLIGON"] = "isCoordinateInsidePoligon";
    FUNCTION_IDS["IS_CURRENT_USER_EMAIL_VERIFIED"] = "isCurrentUserEmailVerified";
    FUNCTION_IDS["IS_LOGGED_IN"] = "isLoggedIn";
    FUNCTION_IDS["IS_UNDEFINED"] = "isUndefined";
    FUNCTION_IDS["ITERATE_CHILDREN"] = "iterateChildren";
    FUNCTION_IDS["JSON_STRINGIFY"] = "jsonStringify";
    FUNCTION_IDS["LAUNCH_APP_REVIEW"] = "launchAppReview";
    FUNCTION_IDS["LAUNCH_APP_UPDATE"] = "launchAppUpdate";
    FUNCTION_IDS["LOGIN"] = "login";
    FUNCTION_IDS["LOGIN_WITH_APPLE"] = "loginWithApple";
    FUNCTION_IDS["LOGIN_WITH_FACEBOOK"] = "loginWithFacebook";
    FUNCTION_IDS["LOGIN_WITH_GOOGLE"] = "loginWithGoogle";
    FUNCTION_IDS["LOGOUT"] = "logout";
    FUNCTION_IDS["MAKE_CALL"] = "makeCall";
    FUNCTION_IDS["MODIFY_DOM"] = "modifyDOM";
    FUNCTION_IDS["OBJECT_KEYS"] = "objectKeys";
    FUNCTION_IDS["OPEN_CALENDAR"] = "openCalendar";
    FUNCTION_IDS["OPEN_GEOMAP"] = "openGeoMap";
    FUNCTION_IDS["OPEN_IMAGE_VIEWER"] = "openImageViewer";
    FUNCTION_IDS["OPEN_PHONE_SETTINGS"] = "openPhoneSettings";
    FUNCTION_IDS["OPEN_REMOTE"] = "openRemote";
    FUNCTION_IDS["OPEN_SIDE_MENU"] = "openSideMenu";
    FUNCTION_IDS["OPEN_URL"] = "openURL";
    FUNCTION_IDS["OPEN_WHATSAPP"] = "openWhatsApp";
    FUNCTION_IDS["PAUSE_PLAYING_AUDIO"] = "pausePlayingAudio";
    FUNCTION_IDS["PAY_USING_APPLE_WALLET"] = "payUsingAppleWallet";
    FUNCTION_IDS["PERMISSION_REQUEST_BUBBLE"] = "permissionRequestBubble";
    FUNCTION_IDS["PERMISSION_REQUEST_REMOTE"] = "permissionRequestRemote";
    FUNCTION_IDS["PRINT_REMOTE_PDF"] = "printRemotePDF";
    FUNCTION_IDS["PUSH_COLLECTION_DOM"] = "pushCollectionDOM";
    FUNCTION_IDS["PUSH_NOTIFICATION_CANCEL_ALL"] = "pushNotificationsCancelAll";
    FUNCTION_IDS["PUSH_NOTIFICATION_REQUEST_PERMISION"] = "pushNotificationRequestPermission";
    FUNCTION_IDS["PUSH_WINDOW"] = "pushWindow";
    FUNCTION_IDS["RANDOM_NUMBER"] = "randomNumber";
    FUNCTION_IDS["RANGE_ITERATOR"] = "rangeIterator";
    FUNCTION_IDS["READ_BARCODE"] = "readBarCode";
    FUNCTION_IDS["READ_QR_CODE"] = "readQRCode";
    FUNCTION_IDS["READ_SMS_ANDROID"] = "readSMSAndroid";
    FUNCTION_IDS["REGEX_TEST"] = "regexTest";
    FUNCTION_IDS["REGEX_TEST_2"] = "regexTest2";
    FUNCTION_IDS["REPLACE_TOP_PAGE"] = "replaceTopPage";
    FUNCTION_IDS["REPLACE_WINDOW"] = "replaceWindow";
    FUNCTION_IDS["RESIZE_IMAGE"] = "resizeImage";
    FUNCTION_IDS["SEARCH_IN_OBJECT"] = "searchInObject";
    FUNCTION_IDS["SEND_ALERT"] = "sendAlert";
    FUNCTION_IDS["SEND_EMAIL_VERIFICATION"] = "sendEmailVerification";
    FUNCTION_IDS["SEND_PUSH"] = "sendPush";
    FUNCTION_IDS["SET_APP_VALUE"] = "setAppValue";
    FUNCTION_IDS["SET_AUDIO_TIME"] = "setAudioTime";
    FUNCTION_IDS["SET_BADGE_BUBBLE"] = "setBadgeBubble";
    FUNCTION_IDS["SET_DATA_DB"] = "setDataDB";
    FUNCTION_IDS["SET_DATA_DB_DIRECT"] = "setDataDbDirect";
    FUNCTION_IDS["SET_DATA_DB_LOCAL_DIRECT"] = "setDataDbLocalDirect";
    FUNCTION_IDS["SET_DATA_LOCAL"] = "setDataLocal";
    FUNCTION_IDS["SET_INTERVAL"] = "setInterval";
    FUNCTION_IDS["SET_OTHER_USER_CUSTOM_DATA"] = "setOtherUserCustomData";
    FUNCTION_IDS["SET_PAGE_VALUE"] = "setPageValue";
    FUNCTION_IDS["SET_PALETTE_COLORS"] = "setPaletteColors";
    FUNCTION_IDS["SET_TIMEOUT"] = "setTimeOut";
    FUNCTION_IDS["SET_USER_CUSTOM_DATA"] = "setUserCustomData";
    FUNCTION_IDS["SHARE"] = "share";
    FUNCTION_IDS["SHOW_BUBBLE"] = "showBubble";
    FUNCTION_IDS["SHOW_FILE_BROWSER"] = "showFileBrowser";
    FUNCTION_IDS["SHOW_IMAGE_VIEWER"] = "showImageViewer";
    FUNCTION_IDS["SIGN_IN"] = "signIn";
    FUNCTION_IDS["START_GEOLOCATION_TRACKING"] = "startGeolocationTracking";
    FUNCTION_IDS["START_GEOLOCATION_TRACKING_HTTP"] = "startGeolocationTrackingHttp";
    FUNCTION_IDS["START_PLAYING_AUDIO"] = "startPlayingAudio";
    FUNCTION_IDS["START_RECORDING_AUDIO"] = "startRecordingAudio";
    FUNCTION_IDS["STOP_GEOLOCATION_TRACKING"] = "stopGeolocationTracking";
    FUNCTION_IDS["STOP_PLAYING_AUDIO"] = "stopPlayingAudio";
    FUNCTION_IDS["STOP_RECORDING_AUDIO"] = "stopRecordingAudio";
    FUNCTION_IDS["STOP_SET_INTERVAL"] = "stopSetInterval";
    FUNCTION_IDS["SWITCH"] = "switch";
    FUNCTION_IDS["TAKE_PHOTO"] = "takePhoto";
    FUNCTION_IDS["TAKE_VIDEO"] = "takeVideo";
    FUNCTION_IDS["TOAST_NOTIFICATION"] = "toastNotification";
    FUNCTION_IDS["TOGGLE_BOTTOM_MENU"] = "toggleBottomMenu";
    FUNCTION_IDS["TOGGLE_PAGE_LOADER"] = "togglePageLoader";
    FUNCTION_IDS["TRIGGER_APP_PROCESS"] = "triggerAppProcess";
    FUNCTION_IDS["TRIGGER_EVENT"] = "triggerEvent";
    FUNCTION_IDS["UDPATE_DATA_FROM_OTHER_USER"] = "updateDataFromOtherUser";
    FUNCTION_IDS["UPDATE_AUTH_INFO"] = "updateAuthInfo";
    FUNCTION_IDS["UPDATE_EMAIL"] = "updateEmail";
    FUNCTION_IDS["UPLOAD_FILE"] = "uploadFile";
    FUNCTION_IDS["UUID_V1"] = "uuidV1";
    FUNCTION_IDS["UX_CAM_RECORD"] = "uxCamRecord";
    FUNCTION_IDS["VIBRATION"] = "vibration";
    FUNCTION_IDS["DB_SECURITY_RULES_ALLOW"] = "0";
    FUNCTION_IDS["OBJECT_BUILD"] = "a";
    FUNCTION_IDS["STRING_INTERPOLATION"] = "b";
    FUNCTION_IDS["HTTP_REQUEST"] = "c";
    FUNCTION_IDS["DEBUG_LOG"] = "d";
    FUNCTION_IDS["ARRAY_FILTER"] = "e";
    FUNCTION_IDS["FIREBASE_REALTIME_DATABASE_SET"] = "f";
    FUNCTION_IDS["UNKNOWN_TO_JSON_STRING"] = "g";
    FUNCTION_IDS["OBJECT_CONCAT"] = "h";
    FUNCTION_IDS["OBJECT_SET"] = "i";
    FUNCTION_IDS["OBJECT_DELETE"] = "j";
    FUNCTION_IDS["OBJECT_FILTER"] = "k";
    FUNCTION_IDS["CODE_COMPUTE"] = "l";
    FUNCTION_IDS["STRIPE_CREATE_CARD_TOKEN"] = "m";
    FUNCTION_IDS["IN_APP_PURCHASE_GET_AVAILABLE_PURCHASES"] = "n";
    FUNCTION_IDS["IN_APP_PURCHASE_GET_PURCHASE_HISTORY"] = "o";
})(FUNCTION_IDS || (exports.FUNCTION_IDS = FUNCTION_IDS = {}));
var FUNCTION_REPORTER_TYPE;
(function (FUNCTION_REPORTER_TYPE) {
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["CONTROL_EVENT"] = 0] = "CONTROL_EVENT";
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["FUNCTION_CALLBACK"] = 1] = "FUNCTION_CALLBACK";
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["FUNCTION_CALLBACKS"] = 2] = "FUNCTION_CALLBACKS";
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["FUNCTIONS_LIST"] = 3] = "FUNCTIONS_LIST";
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["APP_PROCESS"] = 4] = "APP_PROCESS";
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["COMPUTE_ENTRY_VAR"] = 5] = "COMPUTE_ENTRY_VAR";
    FUNCTION_REPORTER_TYPE[FUNCTION_REPORTER_TYPE["PAGE_INPUT_DATA_DEFAULT_ENTRY"] = 6] = "PAGE_INPUT_DATA_DEFAULT_ENTRY";
})(FUNCTION_REPORTER_TYPE || (exports.FUNCTION_REPORTER_TYPE = FUNCTION_REPORTER_TYPE = {}));
var FunctionsListCrawlerPathLinkType;
(function (FunctionsListCrawlerPathLinkType) {
    FunctionsListCrawlerPathLinkType["EVENT"] = "a";
    FunctionsListCrawlerPathLinkType["CONTROL"] = "b";
    FunctionsListCrawlerPathLinkType["FUNCTION"] = "c";
    FunctionsListCrawlerPathLinkType["CALLBACK"] = "d";
    FunctionsListCrawlerPathLinkType["FUNCTION_ENTRY_VAR"] = "e";
    FunctionsListCrawlerPathLinkType["PAGE_DEFAULT_DATA_ENTRY_VAR"] = "f";
    FunctionsListCrawlerPathLinkType["APP_PROCESS"] = "g";
    FunctionsListCrawlerPathLinkType["OBJECT_OF_ENTRY_VARS"] = "h";
    FunctionsListCrawlerPathLinkType["UPDATES_DB_DATA_ENTRY_VAR"] = "i";
    FunctionsListCrawlerPathLinkType["UPDATES_DB_PATH_ENTRY_VAR"] = "j";
    FunctionsListCrawlerPathLinkType["LIST_INSTRUCTION_MODIFICATION_EVENT"] = "k";
    FunctionsListCrawlerPathLinkType["DB_WRITE_PATH"] = "l";
    FunctionsListCrawlerPathLinkType["ENTRY_VAR_ENTRIES_ONE"] = "m";
    FunctionsListCrawlerPathLinkType["ENTRY_VAR_ENTRIES_TWO"] = "n";
    FunctionsListCrawlerPathLinkType["ENTRY_VAR_COMPUTE_FUNCTION"] = "o";
})(FunctionsListCrawlerPathLinkType || (exports.FunctionsListCrawlerPathLinkType = FunctionsListCrawlerPathLinkType = {}));
var FUNCTION_LOACTIONS;
(function (FUNCTION_LOACTIONS) {
    FUNCTION_LOACTIONS["BASE"] = "a";
    FUNCTION_LOACTIONS["APP_PROCESS"] = "b";
    FUNCTION_LOACTIONS["NO_SIDE_EFFECT_APP_PROCESS"] = "c";
    FUNCTION_LOACTIONS["COMPUTER"] = "d";
    FUNCTION_LOACTIONS["ARRAY_FILTER_PREDICATE"] = "e";
})(FUNCTION_LOACTIONS || (exports.FUNCTION_LOACTIONS = FUNCTION_LOACTIONS = {}));
